/**
 * Email message type.
 * tag: 94
 * @readonly
 * @enum {string} (char)
 */
export enum EmailType {
  /** New */
  New = '0',
  /** Reply */
  Reply = '1',
  /** Admin Reply */
  AdminReply = '2',
}
